import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import todoApp from './todo/reducer';
// import chatApp from './chat/reducer';
// import surveyListApp from './surveyList/reducer';
// import surveyDetailApp from './surveyDetail/reducer';
import dummyModule from './dummy/reducer';

import authReducer from './auth/reducer';
import absenceReducer from './absence/reducer';
import activityReducer from './activity/reducer';
import agencyReducer from './agency/reducer';
import agencyConfigReducer from './agencyconfig/reducer';
import budgetCategoryReducer from './budgetcategory/reducer';
import confirmationReducer from './confirmation/reducer';
import costUserReducer from './costuser/reducer';
import dayOffReducer from './dayoff/reducer';
import disciplineReducer from './discipline/reducer';
import executorReducer from './executor/reducer';
import financePersonReducer from './financeperson/reducer';
import instructionReducer from './instruction/reducer';
import jobDescriptionReducer from './jobdescription/reducer';
import notificationReducer from './notification/reducer';
import memberReducer from './member/reducer';
import memberClassReducer from './memberclass/reducer';
import performanceReducer from './performance/reducer';
import positionReducer from './position/reducer';
import positionClassReducer from './positionclass/reducer';
import presenceReducer from './presence/reducer';
import taskReducer from './task/reducer';
import taskCategoryReducer from './taskcategory/reducer';
import taskClassificationReducer from './taskclassification/reducer';
import userReducer from './user/reducer';
import wbsReducer from './wbs/reducer';
import workTimeStandardReducer from './worktimestandard/reducer';
import workUnitReducer from './workunit/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authReducer,
  todoApp,
  // chatApp,
  // surveyListApp,
  // surveyDetailApp,
  dummyModule,

  absenceReducer,
  activityReducer,
  agencyReducer,
  agencyConfigReducer,
  budgetCategoryReducer,
  confirmationReducer,
  costUserReducer,
  dayOffReducer,
  disciplineReducer,
  executorReducer,
  financePersonReducer,
  instructionReducer,
  jobDescriptionReducer,
  memberReducer,
  memberClassReducer,
  notificationReducer,
  performanceReducer,
  positionReducer,
  positionClassReducer,
  presenceReducer,
  taskReducer,
  taskCategoryReducer,
  taskClassificationReducer,
  userReducer,
  wbsReducer,
  workTimeStandardReducer,
  workUnitReducer,
});

export default reducers;
